import React from 'react';
import { Modal } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';
import useUpdatePublishBlog from '../hooks/useUpdatepuplishBlogs';

function UnpublishBlog({
  setUnpublishModal,
  unpublishModal,
  publishData,
  setPublishData,
  BlogId,
  setBlogId,
}) {
  const closeModal = () => {
    setBlogId(null);
    setPublishData(null);
    setUnpublishModal(false);
  };
  const publishaBlog = useUpdatePublishBlog(closeModal);

  return (
    <div>
      <Modal
        opened={unpublishModal}
        onClose={() => {
          setPublishData(null);
          setUnpublishModal(false);
        }}
        title='Are you sure you want to Unpublish?'
        size={'30%'}
        centered
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        transitionDuration={100}
        overflow='inside'
        className='px-10'
        classNames={{
          title: 'text-lg font-semibold  mx-auto',
          body: 'scroller h-36',
        }}
      >
        <div className='flex justify-center items-center gap-3 py-8'>
          <button onClick={() => setUnpublishModal(false)}>
            <SecondaryButton>Cancel</SecondaryButton>
          </button>
          <button
            onClick={() => {
              publishaBlog.mutate({ blog_id: BlogId, is_published: false });
            }}
          >
            <PrimaryButton>Unpublish</PrimaryButton>
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default UnpublishBlog;
